(ns quuppa.qsm.planner.schema
  (:require [malli.core :as m]
            [malli.util :as mu]))

;; Site plan schema.

;; Top level plan includes "nodes" map,
;; with node id => node.
;; There is special ndoe with "root" id, which
;; starts the plan tree.
;; Root and other nodes will refer to children nodes using
;; "children" property which is vector of node ids.

;; "Resources" are files that are currently stored on the filesystem "storage" folder
;; and metadata on separate db table. E.g. background image ndoe will just refer to this
;; using resource-id from its properties map.

;; TODO: All properties should be optional during planning, to allow saving
;; draft plans. Validate as a separate step in the process?

(def coordinate [:or :int :double])

(def BaseProperties
  [:map
   [:name [:string {:min 1}]]])

(def BaseNode
  [:map
   [:type :string]
   [:properties BaseProperties]
   [:children [:vector :string]]])

(def RootNode
  BaseNode)

(def CoordinateSystemNode
  (-> BaseNode))

(def BackgroundImageNode
  (-> BaseNode
      (mu/update :properties mu/merge
                 [:map
                  [:x coordinate]
                  [:y coordinate]
                  [:rotation coordinate]])))

(def ZoneNode
  (-> BaseNode))

(def LocatorNode
  (-> BaseNode
      (mu/update :properties mu/merge
                 [:map
                  [:x coordinate]
                  [:y coordinate]
                  [:z coordinate]])))

;; Building?
;; PE?
;; Room height
;; CS default height

(def Node
  [:multi {:dispatch :type}
   ["Root" RootNode]
   ["Node" BaseNode]
   ["CoordinateSystem" CoordinateSystemNode]
   ["BackgroundImage" BackgroundImageNode]
   ["Zone" ZoneNode]
   ["Locator" LocatorNode]])

(def node-types
  (into #{} (map first (m/children Node))))

(def available-children
  {"Root" #{"CoordinateSystem" "Node"}
   "Node" #{"CoordinateSystem" "Node"}
   "CoordinateSystem" #{"Zone" "BackgroundImage" "Locator"}
   "BackgroundImage" #{}
   "Zone" #{}
   "Locator" #{}})

(def Resource
  :any)

(def SitePlan
  [:map
   {:closed true}
   [:id :int]
   [:nodes [:map-of :string Node]]
   [:resources [:map-of :string Resource]]])

(def NewSitePlan
  (mu/select-keys SitePlan [:nodes]))

(def UpdateSitePlan
  (mu/select-keys SitePlan [:id :nodes]))
